export default __webpack_public_path__ + "static/6806-cf8b40f2d2faff56539ca3dba4d7652e.jpg";